import type { Locale } from "../schema/Locale.js";
import { appDateTimeZone } from "../schema/appDateTimeZone.js";

const formatCache: Partial<Record<Locale, Intl.DateTimeFormat>> = {};
function createFormat(locale: Locale): Intl.DateTimeFormat {
	formatCache[locale] ??= new Intl.DateTimeFormat(locale, {
		day: "numeric",
		month: "numeric",
		year: "numeric",
		timeZone: appDateTimeZone,
	});
	return formatCache[locale];
}

export function toDateMonthYearFormat(date: number | Date | string, locale: Locale): string {
	return createFormat(locale).format(typeof date === "string" ? new Date(date) : date);
}
